/* eslint-disable no-shadow */
/* eslint-disable no-tabs */
/* eslint-disable*/
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import {
	useCallback, useEffect, useMemo, useState
} from 'react';
import {
	analyticsAction, formActions, modalActions
} from '@/Actions';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { CheckCircleIcon, EditIcon } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { ListTable } from '@/Components/ListTable';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { urls } from '@/Constants';
import { classes, filtersInfoChip, handleExportData, handleOrderStatus } from '@/Helpers';
import styles from './StoreAssetOrdersList.module.scss';
import { Button as SButton } from '@/Components/ui/button';
import { notificationServices } from '@/Services';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { POItemsModal } from '@/Components/Modals/POItemsModal';
import { getGroupedAssetObj } from '@/Components/AssetSelector/assetSelector.config';
import GroupAssetCartModal from '@/Components/AssetSelector/GroupAssetCartModal';
import { useAuth } from '@/Components/Auth/Login/auth';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import authActions from '@/Actions/auth.actions';
import { Button, Chip, Tooltip } from '@mui/material';
import GlobalSearch from '@/Components/globalSearch/search';
import { Filter, RefreshCcw } from 'lucide-react';
import { getStorageKey } from '../CreatePurchaseOrder/CreatePurchaseOrder.config';
import { loadState } from '@/Helpers/persistenceUtils';
import { CustomModal } from '@/Components/Modals/CustomModal';

const TABLE_COLUMNS = [
	{
		title: 'Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client PO ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Invoice Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Receive Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatch By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
];
const SPECIAL_COLUMNS = [
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},

	// {
	// title: 'Van Temp',
	// config: {
	// type: 'DATA',
	// },
	// },
	// {
	// title: 'Transit Van Image',
	// config: {
	// type: 'DATA',
	// },
	// },
];
const ACTION_COLUMNS = [
	{
		title: 'Download',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Action',
		config: {
			type: 'CANCEL',
		},
	},
];

const orderStatus = [
	'PENDING',
	'DISPATCH',
	'TRANSIT',
	'UNLOADING',
	'VERIFICATION',
	'FULFILLED',
	'CANCELLED',
	'ABANDONED',
];

const dateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Dispatch By',
		value: 'scheduled',
	},
	{
		label: 'Invoice Date',
		value: 'invoiced',
	},
	{
		label: 'Receive Date',
		value: 'received',
	},
];

const COLMAP = {
	Id: 'id',
	'Client PO ID': 'clientPoId',
	'Order Date': 'createdAt',
	'Invoice Date': 'invoicedAt',
	'Receive Date': 'receivedAt',
	'Dispatch By': 'scheduledAt',
	'Deliver To': 'storeName',
	BASE: 'fromStoreName',
	'Van Temp': 'receivingTemp',
	'Transit Van Image': 'receivingTempImage',
	// 'Transit Van Temp': 'receivingTemp',
	'Order Status': 'orderStatus',
	Vendor: 'vendorName',
};

const userPermissions = {
	MANAGER: true,
};
const SEARCH_BY = {
	options: [
		{
			key: 'clientPoId',
			title: 'Client Po Id',
		},
		{
			key: 'APPROVAL_PENDING',
			title: 'Approval Pending',
		},
	],
};
function StoreAssetOrdersList(props) {
	const {
		data,
		fetchPurchaseOrderList,
		toggleAlert,
		handlePoStatus,
		navState,
		toggleModal,
		userPermissions,
		toggleFiltersDrawer,
		stores,
		toggleCustomModal,
	} = props;
	const history = useHistory();
	const searchQuery = '';
	const searchBy = 'clientPoId';
	const [update, setUpdate] = useState(-1);
	const location = useLocation();
	const [search, setSearch] = useState({});
	const navRequisites = navState?.[urls.INTERNAL_PURCHASE_ORDERS]?.requisites ?? [];
	const selectedNavStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});

	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values(userRolesDict)?.includes('INTERNAL') || Object?.values(userRolesDict)?.includes('CXO Office');

	const levels = [3, 4];

	const [filters, setFilters] = useState({
		storeId: null,
		dateRange: {
			startDate: new Date(),
			endDate: new Date(),
		},
	});
	const [filterValue, setFilterValue] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);

	const handleFetchPurchaseOrderList = (finderFilters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setFilterValue(finderFilters);
		const dateRange = {
			startDate: moment(finderFilters?.dateRange?.from).format(
				'YYYY-MM-DD'
			),
			endDate: moment(finderFilters?.dateRange?.to).format('YYYY-MM-DD'),
			dateType: finderFilters?.timeType?.value,
		};
		setFilters((prev) => {
			return {
				...prev,
				dateRange,
				fulfilledBy: finderFilters?.store,
			};
		});
		const req = {
			data: {
				filters: {
					storeId: finderFilters?.deliverFrom?.id === -999 ? null : finderFilters?.deliverFrom?.id,
					fromStoreId: finderFilters?.store?.id === -999 ? null : finderFilters?.store?.id,
					dateRangeFilter: {
						from: moment(finderFilters?.dateRange?.from).format(
							'YYYY-MM-DD'
						),
						to: moment(finderFilters?.dateRange?.to).format(
							'YYYY-MM-DD'
						),
						dateType: dateRange.dateType,
					},
					status: finderFilters?.status,
					orderType: 'internalStoreAssetOrder',
					...(isRefresh ? null : search?.value === 'poId' ? { poId: search?.searchValue ? Number(search?.searchValue) : null } : { clientPoId: search?.searchValue }),
				},
			},
		};
		fetchPurchaseOrderList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'PO_LIST',
			req,
		});
	};

	const storeIdMap = useMemo(() => {
		const map = {};
		stores?.forEach((store) => {
			map[store?.id] = store;
		});
		return map;
	}, [stores]);

	const isLatLongSameForPOStore = (item) => {
		const fromStoreLatitude = storeIdMap[item?.fromStore]?.latitude;
		const fromStoreLongitude = storeIdMap[item?.fromStore]?.longitude;

		const toStoreLatitude = storeIdMap[item?.storeId]?.latitude;
		const toStoreLongitude = storeIdMap[item?.storeId]?.longitude;

		return (
			fromStoreLatitude === toStoreLatitude &&
			fromStoreLongitude === toStoreLongitude
		);
	};


	const renderDownloadField = (item) => {
		const sendStoreGstin = item?.fromStoreGstin;
		const receiveStoreGstin = item?.storeGstin;

		return (
			<div
				style={{
					width: '125px',
				}}
				className={styles?.downloadDiv}
			>
				{item?.poURL && (
					<Chip
						size='small'
						label='PO'
						onClick={() => {
							if (item?.poURL) {
								window.open(item?.poURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.deliveryChallanURL && (
					<Chip
						size='small'
						label='DC'
						onClick={() => {
							if (item?.deliveryChallanURL) {
								window.open(item?.deliveryChallanURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.woDocUrl && (
					<Chip
						size='small'
						label='WO'
						onClick={() => {
							if (item?.woDocUrl) {
								window.open(item?.woDocUrl);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				<br />
				{item?.invoiceURL && (
					<Chip
						size='small'
						label='Invoice'
						onClick={() => {
							if (item?.invoiceURL) {
								window.open(item?.invoiceURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				{item?.grnURL && (
					<>
						<Chip
							size='small'
							label='GRN'
							onClick={() => {
								if (item?.grnURL) {
									window.open(item?.grnURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					</>
				)}
				{item?.jsonData?.ewayBill?.url ? (
					<>
						<div
							style={{
								display: 'flex',
								position: 'relative',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<Chip
								size='small'
								label='Eway Bill'
								onClick={() => {
									if (item?.jsonData?.ewayBill?.url) {
										const anchor =
											document.createElement('a');
										anchor.href = `https://${item?.jsonData?.ewayBill?.url}`;
										anchor.download = 'EwayBill.pdf';
										anchor.target = 'blank';
										anchor.click();
									}
								}}
								icon={<PictureAsPdfIcon />}
							/>
							{level !== 1 && (
								<EditIcon
									style={{
										position: 'absolute',
										right: '0px',
										cursor: 'pointer',
										backgroundColor: '#f0f0f0',
										color: '#666666',
										padding: '1px',
										borderRadius: '4px',
									}}
									size={16}
									onClick={() => {
										const urlType = 'EWAYBILL';
										const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
										history.push(url);
									}}
								/>
							)}
						</div>
					</>
				) : (
					level !== 1 && item?.orderStatus === 'TRANSIT' &&
					!isLatLongSameForPOStore(item) && (
						<span
							style={{
								cursor: 'pointer',
								color: '#1976d2',
								textDecoration: 'underline',
								fontSize: '12px',
								display: 'inline-block',
								marginLeft: '8px',
								whiteSpace: 'nowrap',
							}}
							onClick={() => {
								const urlType = 'EWAYBILL';
								const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
								history.push(url);
							}}
						>
							Create E-way Bill
						</span>
					)
				)}
				{sendStoreGstin &&
					receiveStoreGstin &&
					((sendStoreGstin !== receiveStoreGstin || item?.jsonData?.eInvoice?.eInvoiceUrl?.length > 0)) &&
					(item?.jsonData?.eInvoice?.eInvoiceUrl ? (
						<>
							{item?.jsonData?.ewayBill?.url ||
								!isLatLongSameForPOStore(item) ? (
								<div style={{
									display: 'flex', position: 'relative', justifyContent: 'center', alignItems: 'center',
								}}
								>
									<Chip
										size='small'
										label='E-Invoice'
										onClick={() => {
											if (item?.jsonData?.eInvoice?.eInvoiceUrl) {
												const anchor = document.createElement('a');
												anchor.href = item?.jsonData?.eInvoice?.eInvoiceUrl;
												anchor.download = 'E-Invoice.pdf';
												anchor.target = 'blank';
												anchor.click();
											}
										}}
										icon={<PictureAsPdfIcon />}
									/>
									{level !== 1 && (
										<EditIcon
											style={{
												position: 'absolute',
												right: '0px',
												cursor: 'pointer',
												backgroundColor: '#f0f0f0',
												color: '#666666',
												padding: '1px',
												borderRadius: '4px',
											}}
											size={16}
											onClick={() => {
												const urlType = 'INVOICE';
												const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
												history.push(url);
											}}
										/>
									)}
								</div>
							) : (
								<span
									style={{
										color: '#a00',
										fontSize: '10px',
										textAlign: 'center',
										display: 'inline-block',
										// marginLeft: '8px',
										width: '100%',
									}}
								>
									*Generate E-way Bill to download Invoices
								</span>
							)}
						</>
					) : (
						level !== 1 &&
						![
							'PENDING',
							'DISPATCH',
							'CANCELLED',
							'ABANDONED',
						].includes(item?.orderStatus) && (
							<span
								style={{
									cursor: 'pointer',
									color: '#1976d2',
									textDecoration: 'underline',
									fontSize: '12px',
									display: 'inline-block',
									marginLeft: '8px',
									whiteSpace: 'nowrap',
								}}
								onClick={() => {
									const urlType = 'INVOICE';
									const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
									history.push(url);
								}}
							>
								Create E-Invoice
							</span>
						)
					))}
			</div>
		);
	};

	const handleApprovePo = async (item) => {
		// setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'APPROVE',
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				toggleModal(false);
				handleFetchPurchaseOrderList(filterValue);
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		// finally {
		// setIsloading(false);
		// }
	};
	const handleRejectPo = async (item, rejectionReason) => {
		// setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'REJECT',
						rejectionReason,
					},
				});
			if (responseData?.statusCode === 200) {
				toggleAlert(false);
				handleFetchPurchaseOrderList(filterValue);
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const handleCancelPo = (id, clientPoId) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Order ${clientPoId || id || ''}`.trim(),
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: 'CANCEL',
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				handleFetchPurchaseOrderList(filterValue);
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const showReviewableItems = (po, reviewable = false) => {
		// const items = po?.items;
		// const tCartItems = {};
		// const tGroupedAssetObjs = items.reduce((acc, item) => {
		// 	const groupedAssetObj = getGroupedAssetObj(item, 'PO_ITEM');
		// 	acc[groupedAssetObj.groupBySpecsKey] = groupedAssetObj;
		// 	tCartItems[groupedAssetObj.groupBySpecsKey] = item.qty;
		// 	return acc;
		// }, {});
		const isInternalObj = {
			'Deliver From Store': po?.vendorName,
			'Deliver To Store GSTIN': po?.storeGstin ?? '',
		};
		// const assetGroupingSummaryData = {
		// 	open: true,
		// 	cartItems: tCartItems,
		// 	groupedAssets: tGroupedAssetObjs,
		// 	extraData: {
		// 		heading: `Items of Order #${po?.clientPoId ?? po?.id}`,
		// 		gridCss: '!grid-cols-2 !w-full',
		// 		containerCss: 'h-[70%]',
		// 	},
		// };
		toggleModal(true, {
			heading: `Items of Internal Store Asset Order #${po?.clientPoId ?? po?.id}`,
			...po,
			approvalText: 'I have checked all the items of Internal Store Asset Order',
			showTotal: false,
			isApprove: reviewable,
			showPdf: true,
			showPoDetails: true,
			transactionData: {
				'Order ID': po?.clientPoId,
				'Deliver To Store': po?.storeName,
				...isInternalObj,
				'Payment Term':
					po?.jsonData?.paymentTerm,
				'Order Date': moment(
					po?.createdAt
				).format('YYYY-MM-DD'),
				'Dispatch By': moment(
					po?.scheduledAt
				).format('YYYY-MM-DD'),
			},
			width: '90%',
			height: '90%',
			excludedColumns: ['Packaged',
				'Ordered Packs',
				'Pack Size',
				'Packaging Name',
				'Production Plan Name',
				'Dispatched',
				'Received',
				'From Process',
				'Standard PO Qty',
				'PO Id', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Recommended Quantity'],
		});
	};

	const handleFulfillAssetOrder = async (id) => {
		try {
			const resp = await inventoryAnalyticsServices.markAssetFullfill(
				{
					data: {
						orderId: id,
						mode: 'dispatch',
						manualFullfiled: true,
					}
				}
			);
			if (resp?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'Internal Asset Order Successfully fulfilled',
				});
				handleFetchPurchaseOrderList(filterValue);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('some error', error);
		} finally {
			toggleCustomModal(false);
		}
	};

	const SPECIAL_ITEMS = {
		Download: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return renderDownloadField(item);
		},
		'Deliver From': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div
					style={{
						width: '200px',
						textAlign: 'left',
					}}
				>
					{item?.fromStoreName ?? '-'}
				</div>
			);
		},
		Action: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const isInternalObj = {
				'Deliver From Store': item?.vendorName,
				'Deliver To Store GSTIN': item?.storeGstin ?? '',
			};
			return (
				<div className={styles.btns}>
					{/* Complete (Mark Complete) button hidden for Asset Transfer orders.
						{([2, 3, 4].includes(level) && (item?.orderStatus === 'DISPATCH') && (
						<Button
							onClick={() => {
								toggleCustomModal(true, {
									header: 'Confirm Completion of Internal Asset Order',
									bodyContent: (
										<div className='space-y-4 p-4'>
											<p className='text-gray-700'>
												You're about to mark this order as complete.
											</p>
											<p className='text-gray-700'>
												If there were any changes during the Asset Order, please make sure
												the Internal Asset Order is updated before proceeding.
											</p>
										</div>
									),
									actionButtons: (
										<div className='flex justify-end space-x-4 p-4'>
											<Button
												onClick={() => {
													handleFulfillAssetOrder(itemId)
												}}
												variant='contained'
												className='bg-yellow-400 hover:bg-yellow-500 text-black'
											>
												Mark Complete
											</Button>
										</div>
									),
									onclose: () => toggleCustomModal(false)
								});
							}}
							variant='outlined'
							className='flex items-center gap-2 border-blue-500 text-blue-600 hover:bg-blue-50'
							startIcon={<CheckCircleIcon className='w-5 h-5' />}
						>
						</Button>
					))}
					*/}
					{(levels.includes(level) && item?.orderStatus === 'APPROVAL_PENDING' &&
						item?.orderStatus !== 'APPROVAL_REJECTED') ? (
						<SButton
							onClick={() => {
								showReviewableItems(item, true);
							}}
							className='primary-btn w-full'
						>
							Review
						</SButton>
					) : null}
					{(item?.orderStatus === 'PENDING' || item?.orderStatus === 'APPROVAL_PENDING') ? (
						<div
							style={{
								width: '125px',
							}}
						>
							<SButton
								variant='outline'
								className='w-full border-red-600 text-red-600 bg-transparent'
								onClick={() => {
									toggleAlert(true, {
										heading: 'Cancel PO?',
										handleConfirm: () => {
											handleCancelPo(
												itemId,
												item?.clientPoId
											);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Cancel ${item?.clientPoId || ''
											}?`,
									});
								}}
								fullWidth
							>
								Cancel PO
							</SButton>
						</div>
					) : (
						'-'
					)}
				</div>
			);
		},
	};

	const viewMoreOptionsList = {
		'View Items': (po, cb) => {
			showReviewableItems(po, false);
			cb();
		},
	};

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			handleFetchPurchaseOrderList(filterValue);
		}
	}
	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			handleFetchPurchaseOrderList(filterValue);
		}
	}, [search?.searchValue]);

	const dropDownItems = [
		{
			label: 'Client PO ID',
			value: 'clientPoId',
			placeholder: 'Search by Client PO ID',
			getData: true,
		},
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by Po ID',
			getData: true,
		},
	];

	const filtersInfo = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
		},
		store: {
			text: 'Deliver From',
			show: true,
		},
		deliverFrom: {
			text: 'Deliver To',
			show: true,
		},
		dateRangeWithType: {
			text: 'Order Date',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
	}
	const exportInfo = {
		showExportBtn: true,
	};
	return (
		<div className={styles.root}>
			<POItemsModal
				handleConfirm={handleApprovePo}
				handleReject={handleRejectPo}
			/>
			<CustomModal />
			<ImagesFinder
				update={update}
				statusList={orderStatus?.map((ele) => {
					if (ele === 'FULFILLED') {
						return {
							id: ele,
							title: 'CLOSED',
						};
					}
					if (ele === 'TRANSIT') {
						return {
							id: ele,
							title: 'IN TRANSIT',
						};
					}
					if (ele === 'DISPATCH') {
						return {
							id: ele,
							title: 'PENDING DISPATCH',
						};
					}
					if (ele === 'UNLOADING') {
						return {
							id: ele,
							title: 'UNLOADING STARTED',
						};
					}
					if (ele === 'VERIFICATION') {
						return {
							id: ele,
							title: 'PENDING VERIFICATION',
						};
					}
					return {
						id: ele,
						title: ele,
					};
				})}
				onSubmit={handleFetchPurchaseOrderList}
				timeTypeArray={dateTypeArr}
				filterLabels={{
					store: 'Deliver From',
					deliverTo: 'Deliver To',
				}}
				orderText
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between items-center w-full p-4'>
				<span className='font-bold text-[16px]'>Asset Transfer Order</span>
				{/* L3 can only approve — order creation stays with other levels */}
				{level !== 1 && level !== 3 && (
					<div className='flex items-center gap-3'>
						{/* Edit Draft Button (conditionally rendered) */}
						{/* {(() => {
							let typeId = 7;

							const storageKey = getStorageKey(typeId);
							const draft = loadState(storageKey);

							if (!draft) return null;

							const storeSelectionText = 'toStore';
							const baseUrl =
								navSelectedStore?.value?.id !== -999
									? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}&${storeSelectionText}=${navSelectedStore?.value?.id}`
									: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}${isInternalOrders
										? '?exclude=1'
										: `?typeId=${typeId}`
									}&userOrderType=purchase`;

							const draftUrl = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}editDraft=true`;

							return (
								<Button
									onClick={() => {
										history.push(draftUrl, {
											prevPath: location?.pathname + location?.search,
										});
									}}
									className="animate-bounce bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										className="h-5 w-5"
										viewBox="0 0 20 20"
										fill="currentColor"
									>
										<path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
									</svg>
									Edit Draft
								</Button>
							);
						})()} */}

						{/* Create Asset Transfer Order buttons.
							Both create the same order (typeId 7 -> type CAPEX / subType
							INTERNAL_STORE_ASSET_ORDER). They differ only in how items are picked:
							- spec linked   : AssetSelector cart, items carry a core-spec fingerprint
							- plain (below) : asset-type table, items carry no specs and the BE
											  stamps jsonData.skipAssetSpecCheck so scanning matches
											  on asset type alone. */}
						{/* Spec Linked Asset Order button hidden.
						<Button
							onClick={() => {
								const toStoreParam =
									selectedNavStore?.value?.id !== -999
										? `?userOrderType=purchase&typeId=7&toStore=${selectedNavStore?.value?.id}`
										: `?userOrderType=purchase&typeId=7`;

								history.push(`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}${toStoreParam}`, {
									prevPath: location?.pathname + location?.search,
								});
							}}
							className="bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black"
						>
							+ Spec Linked Asset Order
						</Button>
						*/}
						<Button
							onClick={() => {
								const toStoreParam =
									selectedNavStore?.value?.id !== -999
										? `?userOrderType=purchase&typeId=7&specLinked=0&toStore=${selectedNavStore?.value?.id}`
										: `?userOrderType=purchase&typeId=7&specLinked=0`;

								history.push(`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}${toStoreParam}`, {
									prevPath: location?.pathname + location?.search,
								});
							}}
							className="bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black"
						>
							+ Create Asset Transfer Order
						</Button>
					</div>
				)}
			</div>
			<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className='w-[82%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip title='Refresh Asset Transfer Orders'>
					<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
						handleFetchPurchaseOrderList(filterValue, true);
					}} />
				</Tooltip>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							exportFrontend: true,
							handleExportFrontend: () => handleExportData(data, COLMAP, 'asset-transfer-order', filterValue),
						});
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filterValue)}
			<div
				className={styles?.table}
				style={{
					width: '100%',
				}}
			>
				<ListTable
					data={data?.map((ele) => {
						return {
							...ele,
							orderStatus: handleOrderStatus(ele?.orderStatus),
							rowStyles: classes(
								styles.row,
								styles?.[ele?.orderStatus]
							),
						};
					})}
					allowExport={false}
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					actions={[...SPECIAL_COLUMNS, ...ACTION_COLUMNS]}
					special={SPECIAL_ITEMS}
					viewMoreOptionsList={viewMoreOptionsList}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { PO_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const categoriesList = state.form.PRODUCT_CATEGORY.data.LIST;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { userList } = state?.auth;
	return {
		data,
		stores,
		navState,
		dateRangeFilter,
		categoriesList,
		subCategoriesList,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleProductionPlanModal: modalActions.toggleProductionPlanModal,
	fetchPurchaseOrderList: analyticsAction.gateway,
	fetchSubCategories: formActions.gateway,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	toggleDebitCreditListDrawer: drawerActions.toggleDebitCreditListDrawer,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	toggleCustomModal: modalActions.toggleCustomModal,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(StoreAssetOrdersList);
